import React, { Component } from 'react';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import Grid from '@material-ui/core/Grid';
import { isMobile } from 'react-device-detect';
import WizardGerente from 'views/WizardGerente/WizardGerente';
import { format } from 'date-fns';
import BotaoMenu from './BotaoMenu';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/prime-table.scss';
import 'assets/css/prime-table.css';
import 'assets/css/documentos.css';
import 'assets/css/geral.css';
import 'assets/css/meus-pedidos.css';
import 'assets/css/pedidos-cirurgia.css';

import { dominioDemandaCirurgica } from '../../config/database';

class Demandas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      demandas: [],
      configuracoes: {},
      filtroCodigo: '',
      dataInclusaoSelecionada: '',
      dataCirurgiaSelecionada: '',
      loading: false,
      profissional: JSON.parse(localStorage.getItem('profissional')),
      renderWizardGerente: false,
      centrosCirurgicosFiltrados: JSON.parse(localStorage.getItem('profissional'))
        .centrosCirurgicos,
      botoesCentroCirurgico: [],
      disableRangeFilter: false,
      periodoFiltrado: null,
      eOnco: '2',
    };
  }

  renderBotoesCentroCirurgico = () => {
    if (this.state.profissional.centrosCirurgicos.length <= 1) {
      this.setState({
        botoesCentroCirurgico: [],
      });
      return;
    }

    const botoes = [];
    dominioDemandaCirurgica.get('/api/centroCirurgico').then(response => {
      response.data.forEach(centroCirurgico => {
        if (this.state.profissional.centrosCirurgicos.includes(centroCirurgico.id))
          botoes.push({
            id: centroCirurgico.id,
            departamento: centroCirurgico.departamento,
          });
      });

      this.setState({
        botoesCentroCirurgico: botoes,
      });
    });
  };

  handleClickBotaoCentroCirurgico = centroCirurgico_id => {
    let { centrosCirurgicosFiltrados } = this.state;
    if (centrosCirurgicosFiltrados.includes(centroCirurgico_id)) {
      if (centrosCirurgicosFiltrados.length === 1) return;
      centrosCirurgicosFiltrados = centrosCirurgicosFiltrados.filter(
        id => id !== centroCirurgico_id
      );
    } else {
      centrosCirurgicosFiltrados.push(centroCirurgico_id);
    }

    this.listarDemandas(centrosCirurgicosFiltrados, this.state.periodoFiltrado, this.state.eOnco);

    this.setState({ centrosCirurgicosFiltrados });
  };

  getFiltrosDemanda = () => {
    return {
      filtroCentroCirurgico: this.state.centrosCirurgicosFiltrados,
      periodoFiltrado: this.state.periodoFiltrado,
    };
  };

  componentDidMount() {
    this.setPeriodoFiltradoInicial();
    this.getConfiguracoes();
    this.renderBotoesCentroCirurgico();
  }

  setPeriodoFiltradoInicial = () => {
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

    const dataInicio = new Date();
    const dataFim = new Date();
    dataFim.setDate(dataFim.getDate() + configuracoes.diasPeriodoFiltroPedidosCirurgia);

    const periodoFiltrado = [dataInicio, dataFim];

    this.setState({
      periodoFiltrado,
    });
    this.listarDemandas(this.state.centrosCirurgicosFiltrados, periodoFiltrado, this.state.eOnco);
  };

  setRenderWizardGerente = valor => {
    this.setState({
      renderWizardGerente: valor,
    });
    document.location.href = `${document.location.href
      .replace('#goku', '')
      .replace('#centroMeusPedidos', '')}#goku`;
  };

  demandasFiltradas = () => {
    let demandasFiltradas = this.state.demandas;

    const { filtroCodigo, dataInclusaoSelecionada, dataCirurgiaSelecionada } = this.state;

    if (filtroCodigo)
      demandasFiltradas = demandasFiltradas.filter(demanda =>
        demanda.codigo.includes(filtroCodigo)
      );

    if (dataInclusaoSelecionada) {
      const filtro = new Date(dataInclusaoSelecionada).toISOString().substring(0, 10);
      demandasFiltradas = demandasFiltradas.filter(demanda =>
        demanda.dataInclusao.includes(filtro)
      );
    }

    if (dataCirurgiaSelecionada) {
      const filtro = new Date(dataCirurgiaSelecionada).toISOString().substring(0, 10);
      demandasFiltradas = demandasFiltradas.filter(demanda =>
        demanda.dataHoraSugerida.includes(filtro)
      );
    }

    return demandasFiltradas;
  };

  listarDemandas = async (centrosCirurgicosFiltrados, periodoFiltrado, eOnco) => {
    this.setState({ loading: true });

    let dataInicioFormatada = null;
    let dataFimFormatada = null;

    if (periodoFiltrado) {
      if (periodoFiltrado[0]) dataInicioFormatada = format(periodoFiltrado[0], 'yyyy-MM-dd');
      if (periodoFiltrado[1]) dataFimFormatada = format(periodoFiltrado[1], 'yyyy-MM-dd');
    }

    const dados = {
      filtros: {
        centrosCirurgicos: centrosCirurgicosFiltrados.join(),
        dataInicio: dataInicioFormatada,
        dataFim: dataFimFormatada,
        eOnco,
      },
    };

    this.setState({ disableRangeFilter: true });
    await dominioDemandaCirurgica.post(`/api/demandaCirurgiaGerente`, dados).then(
      res => {
        this.setState({
          demandas: res.data,
          loading: false,
          disableRangeFilter: false,
        });
      },
      () => {
        this.setState({
          loading: false,
          disableRangeFilter: false,
        });
      }
    );
  };

  getConfiguracoes = () => {
    this.setState({ configuracoes: JSON.parse(localStorage.getItem('configuracoes')) });
  };

  codigoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Nº Demanda</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>{rowData.codigo}</span>
      </>
    );
  };

  pacienteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Paciente</span>
        <div>
          {rowData.GMR === 'True' && <small className="sinalizacao-gmr">GMR</small>}
          {rowData.eOncologica === '1' && <small className="sinalizacao-oncologica">ONCO</small>}
        </div>
        <span>{rowData.paciente}</span>
      </>
    );
  };

  procedimentoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Procedimento</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>{rowData.procedimento}</span>
      </>
    );
  };

  equipeRequisitanteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Equipe Requisitante</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>{rowData.equipeRequisitante}</span>
      </>
    );
  };

  dataInclusaoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data de Inclusão</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>
          {new Date(rowData.dataInclusao).toLocaleString([], {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      </>
    );
  };

  dataSugeridaBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data Cirurgia</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>
          {rowData.dataHoraSugerida === 'Não informado'
            ? 'Não informado'
            : new Date(rowData.dataHoraSugerida).toLocaleString([], {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })}
        </span>
      </>
    );
  };

  profissionalRequisitanteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Profissional Requisitante</span>
        <span className={isMobile ? '' : 'fonte-ajustavel'}>
          {rowData.profissionalRequisitante}
        </span>
      </>
    );
  };

  acoesBodyTemplate = rowData => {
    const configuracoesRecursoSistema = JSON.parse(
      localStorage.getItem('configuracoesRecursoSistema')
    );

    return (
      <BotaoMenu
        rowData={rowData}
        configuracoes={this.state.configuracoes}
        configuracoesRecursoSistema={configuracoesRecursoSistema}
        listarDemandas={this.listarDemandas}
        getFiltrosDemanda={this.getFiltrosDemanda}
        profissionalObservador={this.state.profissional.acessoTodasDemandas === 'V'}
        setRenderWizardGerente={this.setRenderWizardGerente}
      />
    );
  };

  converterFonetico = string => {
    let novaString = string;

    //  Remoção de acentuação
    novaString = novaString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    //  Remoção de letras duplas

    // let caracterAnterior = '';
    // let stringAuxiliar = '';
    // for (const caracter of novaString) {
    //   if (caracter !== caracterAnterior) {
    //     stringAuxiliar += caracter;
    //   }
    //   caracterAnterior = caracter;
    // }

    // Som de S
    novaString = novaString.replace(/Ç/g, 'S');
    novaString = novaString.replace(/Z/g, 'S');
    novaString = novaString.replace(/X/g, 'S');
    novaString = novaString.replace(/CE/g, 'SE');
    novaString = novaString.replace(/CI/g, 'SI');

    // Som de K
    novaString = novaString.replace(/CA/g, 'KA');
    novaString = novaString.replace(/CO/g, 'KO');
    novaString = novaString.replace(/CU/g, 'KU');
    novaString = novaString.replace(/QU/g, 'K');

    // Som de I
    novaString = novaString.replace(/Y/g, 'I');

    // Som de F
    novaString = novaString.replace(/PH/g, 'F');

    // Som de J
    novaString = novaString.replace(/GE/g, 'JE');
    novaString = novaString.replace(/GI/g, 'JI');

    // Som de G
    novaString = novaString.replace(/GU/g, 'G');

    // Som de M
    novaString = novaString.replace(/N/g, 'M');

    // Som de V
    novaString = novaString.replace(/W/g, 'U');

    return novaString;
  };

  customFilterFonetico = (value, filter) => {
    return this.converterFonetico(value.toUpperCase()).includes(
      this.converterFonetico(filter.toUpperCase())
    );
  };

  handleOncologia = async () => {
    if (this.state.eOnco === '2') {
      await this.setState({ eOnco: '1' });
    } else {
      await this.setState({ eOnco: '2' });
    }

    this.listarDemandas(
      this.state.centrosCirurgicosFiltrados,
      this.state.periodoFiltrado,
      this.state.eOnco
    );
  };

  render() {
    //  #region componentes
    const pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
      monthNames: [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ],
      monthNamesShort: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sm',
    };

    const dateInclusaoFilter = (
      <Calendar
        locale={pt}
        value={this.state.dataInclusaoSelecionada}
        onChange={e => {
          this.setState({ dataInclusaoSelecionada: e.value });
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const dateSugeridaFilter = (
      <Calendar
        locale={pt}
        value={this.state.dataCirurgiaSelecionada}
        onChange={e => {
          this.setState({ dataCirurgiaSelecionada: e.value });
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const header = (
      <>
        <div className="table-header campo-filtro">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={e => this.setState({ globalFilter: e.target.value })}
              placeholder="Pesquise pela descrição dos campos..."
              style={{ width: '78vw', height: '6vh' }}
            />
          </span>
        </div>
      </>
    );

    //  #endregion

    if (this.state.renderWizardGerente)
      return (
        <WizardGerente
          setRenderWizardGerente={this.setRenderWizardGerente}
          listarDemandas={this.listarDemandas}
          getFiltrosDemanda={this.getFiltrosDemanda}
        />
      );

    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <br />
            <div className="grupo-botoes-filtros">
              <div>
                <label
                  htmlFor="filtroPeriodoDataInclusao"
                  style={{
                    display: 'block',
                    fontSize: '1vw',
                    color: 'black',
                  }}
                >
                  Periodo da Data de Inclusão
                </label>
                <Calendar
                  id="filtroPeriodoDataInclusao"
                  locale={pt}
                  value={this.state.periodoFiltrado}
                  onChange={async e => {
                    await this.listarDemandas(
                      this.state.centrosCirurgicosFiltrados,
                      e.value,
                      this.state.eOnco
                    );
                    this.setState({ periodoFiltrado: e.value });
                  }}
                  disabled={this.state.disableRangeFilter}
                  dateFormat="dd/mm/yy"
                  selectionMode="range"
                  readOnlyInput
                  showIcon
                  showButtonBar
                  style={{
                    width: '20vw',
                  }}
                />
              </div>
              <div className="div-botoes-filtros">
                <div className="div-botoes-filtro-centro-cirurgico">
                  <span className="p-buttonset">
                    {this.state.botoesCentroCirurgico.map(botao => (
                      <Button
                        label={botao.departamento}
                        key={botao.id}
                        onClick={() => this.handleClickBotaoCentroCirurgico(botao.id)}
                        className={
                          this.state.centrosCirurgicosFiltrados.some(
                            idCentroCirurgico => idCentroCirurgico === botao.id
                          )
                            ? ''
                            : 'botao-filtro-desabilitado'
                        }
                      />
                    ))}
                  </span>
                </div>
              </div>
              <Button
                label="ONCO"
                key={1}
                style={{ height: '40px' }}
                className={
                  this.state.eOnco === '1' ? 'button-oncologia' : 'button-oncologia-desabilitado'
                }
                onClick={this.handleOncologia}
              />
            </div>
            <Card>
              <CardHeader color="rose" id="centroMinhasDemandas" className="card-header">
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <p className="card-title">
                      <strong>Demandas</strong>
                    </p>
                  </Grid>
                </Grid>
              </CardHeader>
              <CardBody className="card-body-0-padding">
                <div id="table-demandas" className="datatable">
                  <div className="card">
                    <DataTable
                      ref={el => {
                        this.dt = el;
                      }}
                      value={this.demandasFiltradas()}
                      paginator
                      header={header}
                      globalFilter={this.state.globalFilter}
                      rows={10}
                      className="p-datatable-prime"
                      emptyMessage="Sem demandas"
                      loading={this.state.loading}
                      first={this.state.first}
                      onPage={e => {
                        this.setState({ first: e.first });
                        document.location.href = `${document.location.href
                          .replace('#centroMinhasDemandas', '')
                          .replace('#goku', '')}#centroMinhasDemandas`;
                      }}
                    >
                      <Column
                        field="codigo"
                        header="Nº Demanda"
                        sortable
                        body={this.codigoBodyTemplate}
                        filter
                        headerStyle={{ width: '12%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterPlaceholder="Nº Demanda"
                        filterMatchMode="contains"
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="paciente"
                        header="Paciente"
                        sortable
                        body={this.pacienteBodyTemplate}
                        filter
                        headerStyle={{ width: '12%' }}
                        filterPlaceholder="Nome"
                        filterMatchMode="contains"
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="dataInclusao"
                        header="Data de Inclusão"
                        sortable
                        body={this.dataInclusaoBodyTemplate}
                        filter
                        filterElement={dateInclusaoFilter}
                        headerStyle={{ width: '12%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="dataHoraSugerida"
                        header="Data Cirurgia"
                        sortable
                        body={this.dataSugeridaBodyTemplate}
                        filter
                        filterElement={dateSugeridaFilter}
                        headerStyle={{ width: '12%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="equipeRequisitante"
                        header="Equipe"
                        sortable
                        body={this.equipeRequisitanteBodyTemplate}
                        filter
                        filterPlaceholder="Equipe"
                        filterMatchMode="contains"
                        headerStyle={{ width: '12%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="profissionalRequisitante"
                        header="Requisitante"
                        sortable
                        body={this.profissionalRequisitanteBodyTemplate}
                        filter
                        filterPlaceholder="Requisitante"
                        filterMatchMode="contains"
                        headerStyle={{ width: '12%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        field="procedimento"
                        header="Procedimento"
                        sortable
                        body={this.procedimentoBodyTemplate}
                        filter
                        filterPlaceholder="Procedimento"
                        filterMatchMode="contains"
                        headerStyle={{ width: '12%' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                        filterHeaderClassName="select-table-header"
                      />
                      <Column
                        header="Ações"
                        body={this.acoesBodyTemplate}
                        filterHeaderClassName="select-table-header"
                        headerStyle={{ textAlign: 'center', width: '8%' }}
                        bodyStyle={{ textAlign: 'center' }}
                        headerClassName={isMobile ? '' : 'fonte-ajustavel'}
                      />
                    </DataTable>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default Demandas;
